module.exports = __webpack_public_path__ + "img/img-hero03.27efc02e.jpg";